import { render, staticRenderFns } from "./relatorio_vendas.vue?vue&type=template&id=01cdc571&class=home"
import script from "./relatorio_vendas.vue?vue&type=script&lang=js"
export * from "./relatorio_vendas.vue?vue&type=script&lang=js"
import style0 from "./relatorio_vendas.vue?vue&type=style&index=0&id=01cdc571&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports